import { Injectable } from '@angular/core';
import { BaseService } from './base/base.service';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Threed } from '../../model/threed';
import { PaymentModel } from '../../model/payment.model';
import { PaymentStartResult } from '../../model/payment.start.result';
import { NumberModel } from '../../model/user/number.model';
import { SendOtpResult } from '../../model/send-otp-result';
import { Payment } from '../../model/payment';
import { PaymentResult } from '../../model/payment.result';

@Injectable({
  providedIn: 'root'
})
export class PaymentService extends BaseService {

  resourceUrl = 'payment';

  //Kullanıcı kartlarını getiren servis methodu
  getPaymentMethods(trackingId: string): Observable<PaymentModel> {
    return this.get(`${trackingId}`);
  }

  //Threed için html çıktısı alan servis methodu.
  getThreeDContent(sessionId: string, trackingId: string): Observable<Threed> {
    return this.get(`threeD/${trackingId}` + '?sessionId=' + sessionId);
  }

  //Threed sonrası ödemeyi kontrol eden servis.
  getThreeDResult(sessionId: string, trackingId: string): Observable<PaymentStartResult> {
    return this.get(`threeD/result/${trackingId}` + '?sessionId=' + sessionId);
  }

  //Ödeme Sonucunu Sorgulayan Servis.
  getPaymentResult(id: string, trackingId: string): Observable<PaymentResult> {
    return this.get(`result/${trackingId}` + '?id=' + id)
  }

  //Ödeme Öncesi Paycell Şifresi Doğrulatan Servis
  postPaymentPin(numberModel: NumberModel, trackingId: string): Observable<SendOtpResult> {
    return this.post(`pin/${trackingId}`, numberModel);
  }

  //Ödeme Öncesi Otp,Sms,Pin,Threed gibi kontrolleri yapan servis.
  checkPaymentStatus(payment: Payment, trackingId: string): Observable<PaymentStartResult> {
    return this.post(`check-payment-status/${trackingId}`, payment);
  }

  //Ödemeyi Sağlayan Servis.
  makePayment(payment: Payment, trackingId: string): Observable<PaymentStartResult> {
    return this.post(`make-payment/${trackingId}`, payment);
  }

  //Ödeme Aşamasında Kullanıcıya Otp Gönderen Servis.
  sendOtpToUser(trackingId: string): Observable<SendOtpResult> {
    return this.get(`otp-send/${trackingId}`);
  }

  //Ödeme sırasındaki otp'yi kontrol eden servis.
  checkOtp(numberModel: NumberModel, trackingId: string): Observable<SendOtpResult> {
    return this.post(`otp-check/${trackingId}`, numberModel);
  }

  //Sms ile ödeme case'i sırasında ödemeyi sorgulayan servis.
  queryDcbPaymentStatus(trackingId: string): Observable<PaymentStartResult> {
    return this.get(`sms/dcb/${trackingId}`);
  }


  getHttpParams(): HttpParams {
    return undefined;
  }

  getPath(): string {
    return this.resourceUrl;
  }
}
